import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCancelOrder } from "./cancelOrder.request";

const useCancelOrder = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCancelOrder,
    ...options
  });
};

export default useCancelOrder;
